/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/naming-convention */
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  catchError,
  from,
  map,
  mergeMap,
  Observable,
  of,
  throwError,
} from 'rxjs';
import { Auth } from '@aws-amplify/auth';
import { CognitoUserSession } from 'amazon-cognito-identity-js';

const getToken = (): Observable<string | null> => {
  return from(Auth.currentSession()).pipe(
    map((session: CognitoUserSession) => {
      return session.getIdToken().getJwtToken();
    }),
    // Catch error and return null
    catchError(() => {
      return of(null);
    }),
  );
};

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return getToken().pipe(
      mergeMap((token) => {
        if (token) {
          // Clone the request with the Authorization header
          const cloned = req.clone({
            headers: req.headers.set('Authorization', token),
            // .set('Access-Control-Allow-Origin', '*')
            // .set('Access-Control-Allow-Headers', '*')
            // .set('Access-Control-Allow-Methods', '*')
            // .set('Content-Type', 'application/json'),
          });
          return next.handle(cloned);
        } else {
          // Handle the request without an Authorization header if no token is available
          return next.handle(req);
        }
      }),
      catchError((error) => {
        console.error('Interceptor error:', error);
        return throwError(() => error);
      }),
    );
  }
}
